import { FC, ReactNode } from 'react';
import { StyledDialogTitle } from '../style';
import { DRAGGABLE_DIALOG_ID } from '..';
import { useDraggable } from '@dnd-kit/core';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography, { TypographyProps } from '@mui/material/Typography';
import { CloseIcon } from 'assets/icons/CloseIcon';
import { secondary } from 'assets/colors/colors';

interface IDialogHeaderProps {
  showHeader?: boolean;
  variant: 'primary' | 'error' | 'secondary';
  isDraggable?: boolean;
  dialogTitle?: ReactNode;
  title?: string;
  hideCloseButton: boolean;
  onClose: () => void;
  titleColor?: string;
  titleVariant: TypographyProps['variant'];
}

export const DialogHeader: FC<IDialogHeaderProps> = ({
  showHeader,
  variant,
  isDraggable,
  dialogTitle,
  title,
  onClose,
  titleColor = secondary.main,
  titleVariant,
}) => {
  const { listeners } = useDraggable({
    id: DRAGGABLE_DIALOG_ID,
    disabled: !isDraggable,
  });

  if (!showHeader) return null;

  if (dialogTitle) {
    return (
      <StyledDialogTitle
        $variant={variant}
        {...(isDraggable ? listeners : {})}
        sx={{
          cursor: isDraggable ? 'move' : 'default',
        }}
      >
        {dialogTitle}
      </StyledDialogTitle>
    );
  }

  return (
    <StyledDialogTitle
      $variant={variant}
      sx={{
        paddingY: dialogTitle ? '16px' : '0',
      }}
    >
      <Stack
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Stack
          {...(isDraggable ? listeners : {})}
          width="100%"
          height="100%"
          paddingY="16px"
          sx={{
            cursor: isDraggable ? 'move' : 'default',
          }}
        >
          <Typography variant={titleVariant || 'subtitle1'} color={titleColor}>
            {title}
          </Typography>
        </Stack>
        {onClose && (
          <IconButton
            onClick={() => {
              onClose();
            }}
          >
            <CloseIcon />
          </IconButton>
        )}
      </Stack>
    </StyledDialogTitle>
  );
};
